module.exports = __webpack_public_path__ + "static/media/VV 8-10.314f8cb7.mp3";